import PropTypes from 'prop-types';
import React from 'react';
import { setClassNames } from '../utils/utility';

const Location = props => {
	const {
		icon,
		displayStatusElement,
		locationElement,
		displayLink,
		linkLabel,
		dataWidth,
		href,
		relData,
		dataHref,
		dataTitle,
		isMobile
	} = props.displayObj;
	let {
		displayStatusClass,
		linkClass,
		vehicleStatusDisplay,
		location
	} = props.displayObj;

	if (displayStatusElement === 'strong') {
		vehicleStatusDisplay = <strong>{vehicleStatusDisplay}</strong>;
	}
	if (locationElement === 'strong') {
		location = <strong>{location}</strong>;
	}

	const iconColorClass = icon === 'lock' ? 'text-danger' : '';
	const iconSizeClass = isMobile
		? 'ddc-font-size-xxlarge'
		: 'ddc-font-size-xlarge';
	const iconWrapperClass = setClassNames(
		'ddc-icon',
		`ddc-icon-${icon}`,
		iconColorClass,
		iconSizeClass
	);
	const locationMarginClass = isMobile ? 'my-0' : 'mr-5';
	const locationClass = ['d-sm-inline', locationMarginClass].join(' ');

	const displayStatusMarginClass = isMobile ? 'my-0' : '';
	displayStatusClass = setClassNames(
		'd-sm-inline',
		displayStatusMarginClass,
		displayStatusClass
	);

	linkClass = isMobile
		? setClassNames('d-block', 'mt-3', 'py-0', linkClass)
		: linkClass;

	return (
		<div
			className={setClassNames(
				'vehicle-location-wrapper',
				'box',
				'box-border',
				'd-flex',
				'align-items-start',
				'align-items-sm-center',
				'line-height-condensed',
				'm-0',
				'p-3',
				'p-sm-4'
			)}
		>
			<div className="d-sm-inline pr-3 pl-2 pl-sm-0">
				<i className={iconWrapperClass} />
			</div>
			<div className="py-2 py-sm-0">
				<div className={displayStatusClass}>
					{vehicleStatusDisplay}{' '}
				</div>
				<div className={locationClass}>{location}</div>
				{displayLink && (
					<a
						className={linkClass}
						href={href}
						rel={relData}
						data-width={dataWidth}
						data-href={dataHref}
						data-title={dataTitle}
					>
						{linkLabel}
					</a>
				)}
			</div>
		</div>
	);
};

Location.propTypes = {
	displayObj: PropTypes.shape({
		icon: PropTypes.string.isRequired,
		vehicleStatusDisplay: PropTypes.string.isRequired,
		location: PropTypes.string.isRequired,
		displayStatusElement: PropTypes.string.isRequired,
		locationElement: PropTypes.string.isRequired,
		displayStatusClass: PropTypes.string.isRequired,
		displayLink: PropTypes.bool.isRequired,
		linkLabel: PropTypes.string.isRequired,
		linkClass: PropTypes.string,
		dataWidth: PropTypes.number,
		href: PropTypes.string,
		dataHref: PropTypes.string,
		relData: PropTypes.string,
		dataTitle: PropTypes.string,
		flags: PropTypes.shape({
			'ws-vehicle-location-remove-margin': PropTypes.bool
		}),
		isMobile: PropTypes.bool
	}).isRequired
};

export default Location;



// WEBPACK FOOTER //
// ./src/components/Location.jsx